export enum Status {
    MajorOutage = 'major_outage',
    PartialOutage = 'partial_outage',
    UnderMaintenance = 'under_maintenance',
    DegradedPerformance = 'degraded_performance',
    Operational = 'operational'
}
